import { Card, Typography } from "antd"
import { useCallback } from "react"
import { Link, useParams } from "react-router-dom"
import { regulatoryApi } from "../../utils/regulatoryApi"
import { CatalogFrame, PointDetails, ResourceState } from "./components/CatalogUI"
import { useCatalogResource } from "./useCatalog"
export function PointDetailPage() {
  const { revisionUuid } = useParams<{ revisionUuid: string }>()
  const resource = useCatalogResource(
    useCallback((signal) => regulatoryApi.point(revisionUuid, signal), [revisionUuid]),
  )
  return (
    <CatalogFrame
      title="Définition du point"
      extra={<Link to="/regulatory/points">Retour aux points</Link>}
    >
      <ResourceState {...resource} retry={resource.reload}>
        {resource.data && (
          <Card title={resource.data.definition.label}>
            <Typography.Paragraph type="secondary">
              Cette définition correspond à une révision précise du point.
            </Typography.Paragraph>
            <PointDetails point={resource.data} />
            <Typography.Paragraph type="secondary" copyable>
              Révision : {resource.data.uuid}
            </Typography.Paragraph>
          </Card>
        )}
      </ResourceState>
    </CatalogFrame>
  )
}
